import type { FileError } from 'react-dropzone';
import { ErrorCode } from 'react-dropzone';

const ONE_MEGABYTE = 1024 * 1024;

export const MAX_CONTRACT_PDF_FILES = 10;

export const DROP_ZONE_CONFIG = {
  accept: { 'application/pdf': ['.pdf'] },
  maxSize: ONE_MEGABYTE * 10,
  maxFiles: MAX_CONTRACT_PDF_FILES,
};

export function getErrorMessage(error: FileError): string {
  switch (error.code) {
    case ErrorCode.FileInvalidType:
      return 'Unsupported file type. Please upload a PDF file.';
    case ErrorCode.FileTooLarge:
      return 'File too large. Maximum size is 10MB.';
    case ErrorCode.TooManyFiles:
      return `Too many files. Maximum ${MAX_CONTRACT_PDF_FILES} files are allowed.`;
    default:
      return 'An error occurred while uploading the file.';
  }
}
